import { WrapperGS, WrapperValued } from '../core/WrapperGS';

export class OptionGS extends WrapperGS<HTMLOptionElement> implements WrapperValued
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "option";
    }

    constructor(el: HTMLOptionElement|string)
    {
        super(el);
    }

    public get value() { return this.el.value; }
    public set value(value: string) { this.el.value = value; }

    public get label() { return this.el.label; }
    public set label(value: string) { this.el.label = value; }

    public override get text() { return this.el.text; }
    public override set text(value: string) { this.el.text = value; }

    public get selected() { return this.el.selected; }
    public set selected(value: boolean) { this.el.selected = value; }

    public get disabled() { return this.el.disabled; }
    public set disabled(value: boolean) { this.el.disabled = value; }
}
WrapperGS.ExtendComponentsByHTMLElement(OptionGS);
